import React, { useState, useRef, useEffect } from 'react'

import '../styles/Home.css'

import TypeWriterEffect from 'react-typewriter-effect';
import { animateScroll } from 'react-scroll';
import { Link } from 'react-scroll';

const Home = () => {
  const [number, setNumber] = useState(0);
  const arrayOfWords = ['Tap again', 'Helllo There', 'You found this', 'Great', 'now', `go to`, 'bottom of page', 'and message me', 'ill give you', 'A Reward', `🏆`,]
  const textContent = useRef();


  const handleClickResume = () => {
    window.open("https://drive.google.com/drive/folders/1uQkYma2wjfpyupdSbz3uycstqq-y9q4p?usp=sharing", "_blank")
  }

  const handleChange = () => {
    textContent.current.style.display = 'inline-block';
    textContent.current.innerText = arrayOfWords[number]
    if ((arrayOfWords.length - 1) !== number) {
      setNumber(number + 1)
    }
    if ((arrayOfWords.length - 1) === number) {
      // something will be here soon
      setTimeout(() => {
        textContent.current.style.display = 'none'
        animateScroll.scrollTo(350)
        setNumber(1)
      }, 1000);
    }
  }

  const [imageUrl, setImageUrl] = useState("https://spotify-github-profile.kittinanx.com/api/view.svg?uid=31hgv3hncqa5p4qme3hi7ll7nyeu&cover_image=true&theme=default&show_offline=true&background_color=232135&interchange=true&bar_color_cover=false");

  useEffect(() => {
    const interval = setInterval(() => {
      setImageUrl(imageUrl + "?timestamp=" + new Date().getTime());
    }, 5000);
    return () => clearInterval(interval);
  }, [imageUrl]);


  return (
    <div className='home' id='home'>
      <div className='spotifystatus'>
        <a href="https://spotify-github-profile.kittinanx.com/api/view.svg?uid=31hgv3hncqa5p4qme3hi7ll7nyeu&redirect=true">
          <img src={imageUrl} alt="Spotify status" />
        </a>
      </div>
      <div className="home-text">
        <h1>
          <span className='gradientText'>
            Hi, I'm Kunal!
          </span>
          <span>
            <span onClick={handleChange}>
              👋
            </span>
            <span ref={textContent} style={{ display: 'none' }}>
              Tap again
            </span>
          </span>
        </h1>
        <TypeWriterEffect
          cursorColor="#1da1f2"
          multiText={[
            "👨‍💻 C++ Programming 👨‍💻",
            "⛩️ Otaku ⛩️",
            "🐍 Python 🐍",
            "🌐 Web Developement 🌐",
            "🎮 Game Developer 🎮",
            "Done Thats all !😊"

          ]}
          multiTextLoop={true}
          multiTextDelay={1500}
          typeSpeed={35}
        />
        <div className="btns">
          <Link className='btn1' activeClass="active" to="mail" spy={true} smooth={true} offset={0} duration={500}>
            Contact Me
          </Link>
          <div className='btn2' onClick={handleClickResume} align="center">View Resume</div>
        </div>
      </div>
    </div >
  )
}

export default Home;
